import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/content";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mogul-build/artifacts/vp4d7ffa_ChatGPT%20Image%20Nov%2028%2C%202025%2C%2004_57_25%20PM.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white transition-shadow ${scrolled ? "shadow-[0_2px_20px_rgba(0,0,0,0.05)]" : ""} border-b border-gray-100`}
    >
      <div className="container-wide flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <div className="font-serif text-2xl leading-none tracking-tight">
            <span className="text-[#0A0A0A]">T</span>
            <span className="text-gold">M</span>
            <span className="text-[#0A0A0A]">G</span>
          </div>
          <div className="hidden sm:flex flex-col leading-none border-l border-gray-200 pl-3">
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#0A0A0A] font-semibold">The Mogul Group</span>
            <span className="text-[9px] tracking-[0.25em] uppercase text-gold mt-1">Advisors</span>
          </div>
          <span className="sr-only">The Mogul Group Advisors</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {NAV_LINKS.filter((l) => l.label !== "Growth Assessment").map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[13px] tracking-wide uppercase font-medium transition-colors ${isActive ? "text-gold" : "text-[#0A0A0A] hover:text-gold"}`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/growth-assessment" data-testid="nav-cta-assessment" className="btn btn-primary">
            Get My Free Growth Assessment
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white" data-testid="nav-mobile-menu">
          <div className="container-wide py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `text-base ${isActive ? "text-gold" : "text-[#0A0A0A]"}`}
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/growth-assessment" data-testid="nav-mobile-cta" className="btn btn-primary w-full justify-center mt-2">
              Get My Free Growth Assessment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
